module.exports = __webpack_public_path__ + "static/reyelle@2x-bd8ad8a5507d73a35392f7cdda38f1de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pricing/reyelle@2x.jpg
// module id = 933
// module chunks = 18116671869107 235176306749093